
export default {
  name: 'ProductVideoStructuredData',
  props: {
    videos: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
  },
  head() {
    if (!this.structuredData.length) return {}
    return {
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          hid: 'product-video-structured-data',
          innerHTML: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': this.structuredData,
          }),
          type: 'application/ld+json',
        },
      ],
    }
  },
  computed: {
    plainDescription() {
      const text = (this.description || '')
        .replace(/<[^>]+>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
      return text || this.name
    },
    structuredData() {
      const usable = this.videos.filter(
        media =>
          media?.video?.url && media?.image?.url && media.video.uploaded_at
      )
      return usable.map((media, index) => ({
        '@type': 'VideoObject',
        name:
          media.video.label ||
          (usable.length > 1
            ? `${this.name} – ${this.$t(
                'components.viewerImages.videoLabel'
              )} ${index + 1}`
            : `${this.name} – ${this.$t(
                'components.viewerImages.videoLabel'
              )}`),
        description: this.plainDescription,
        thumbnailUrl: this.absolute(media.image.url),
        contentUrl: this.absolute(media.video.url),
        uploadDate: media.video.uploaded_at,
        inLanguage: this.$i18n.locale,
      }))
    },
  },
  methods: {
    absolute(url) {
      return url.startsWith('http') ? url : `${this.$config.url}${url}`
    },
  },
}
